<template>
    <ContainerWithMenu>
        <div class="page-content">
            <h1 class="h2 margin-0">Registro dei Corrispettivi</h1>
        </div>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";

    export default {
        name: "FeeLog",
        components: { ContainerWithMenu }
    };
</script>
